export default "__VITE_ASSET__CnUA2ejT__"